import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=41b35139&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b35139')) {
      api.createRecord('41b35139', component.options)
    } else {
      api.reload('41b35139', component.options)
    }
    module.hot.accept("./DetailPage.vue?vue&type=template&id=41b35139&", function () {
      api.rerender('41b35139', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/goods-receipt-price/DetailPage.vue"
export default component.exports